// @flow

import memoize from 'memoize-one';

import { Customer, CustomerGroupGenerator } from './customer';
import { Pizza } from './pizza';
import { Rng } from '../../../../utils/Random';
import { calculateCustomerCount, ratingToMultiplier } from './constants';

export type FutureRound = { name: string };
export type NewRound = {|
  name: string,
  customers: Customer[],
|};
export type FinishedRound = {|
  name: string,
  customers: Customer[],
  pizza: Pizza,
|};

export const Round = {
  ratings: memoize((round: FinishedRound): Array<{| customer: Customer, rating: number |}> => {
    return round.customers.map(customer => ({ customer, rating: customer.satisfactionScore(round.pizza) }));
  }),
  totalRating: memoize((round: FinishedRound): number => {
    return Round.ratings(round).reduce((acc, { rating }) => acc + rating, 0);
  }),
  sale: memoize((round: FinishedRound): number => {
    const base = round.pizza.basePrice;
    return Math.floor(Round.ratings(round).reduce((acc, { rating }) => acc + base * ratingToMultiplier(rating), 0));
  }),
  create: (name: string, totalRating: number, rng: Rng): NewRound => {
    const customerCount = calculateCustomerCount(totalRating);

    return { name, customers: CustomerGroupGenerator(customerCount).gen(rng) };
  },
  random: (name: string, rng: Rng): NewRound => {
    const customerCount = 1;
    return { name, customers: CustomerGroupGenerator(customerCount).gen(rng) };
  },
};

export const History = {
  totalSale: memoize((rounds: FinishedRound[]): number => {
    return rounds.reduce((acc, round) => acc + Round.sale(round), 0);
  }),
  totalRating: memoize((rounds: FinishedRound[]): number => {
    return rounds.reduce((acc, round) => acc + Round.totalRating(round), 0);
  }),
};
